<template>
    <BreadCrumb PageTitle="Détails d'une zone tarifaire" />
    <ViewTariffZone/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ViewTariffZone from "@/components/ZoneTarifaire/ViewTariffZone.vue";
  
    export default defineComponent({
      name: "ViewTariffZonePage",
      components: {
        BreadCrumb,
        ViewTariffZone,
      },
    });
  </script>